import { render } from "./VideoMyInvestList.vue?vue&type=template&id=2a92b64c"
import script from "./VideoMyInvestList.vue?vue&type=script&lang=js"
export * from "./VideoMyInvestList.vue?vue&type=script&lang=js"

import "./VideoMyInvestList.vue?vue&type=style&index=0&id=2a92b64c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__